import { useSiteState } from "@context/siteContext"
import useGlossary from '@utils/useGlossary'

const useTranslatedString = (stringText, parent) => {
	// Default to english if no language exists

	const glossary = useGlossary()
	let s

	if(glossary?.hasOwnProperty(stringText) || (glossary?.hasOwnProperty(parent) && glossary[parent]?.hasOwnProperty(stringText))){
		s = !parent ? glossary[stringText] : glossary[parent][stringText]
		if(parent){
			// console.log(glossary[parent][stringText])
		}
	} else {
		return 'No string found'
	}

	const [ siteState ] = useSiteState()

	const language = siteState?.checklistLanguage 

	return s?.hasOwnProperty(language) && s[language] ? s[language] : s?.en
}

export default useTranslatedString

